export const getMuid = (state) => {
    return state.muid
}

export const getStatus = (state) => {
    return state.status
}

export const getSubject = (state) => {
    return state.subject
}

export const getSender = (state) => {
    return state.sender
}

export const getPoints = (state) => {
    return state.points
}

export const getDate = (state) => {
    return state.date
}

export const getForwardTo = (state) => {
    return state.forward_to
}

export const getEmailBody = (state) => {
    return state.email_body
}

export const getIsLoading = (state) => {
    return state.isloading
}

export const getPanelist = (state) => {
    return state.panelist_id
}

export const getFirstname = (state) => {
    return state.first_name
}

export const getLastname = (state) => {
    return state.last_name
}

export const getPanelistemail = (state) => {
    return state.panelistemail
}
export const getAge = (state) => {
    return state.age
}
export const getState = (state) => {
    return state.state
}

export const getForwardeddata = (state) => {
    return state.forwardeddata
}
export const getSubjectdata = (state) => {
    return state.subjectdata
}
export const getHtmlbody = (state) => {
    return state.htmlbody
}
export const getEmailRead = (state) => {
    return state.emailRead
}
export const getPanelistCore = (state) => {
    return state.panelistCore
}
export const getPanelistScore = (state) => {
    return state.panelistScore
}
export const getIndexName = (state) => {
    return state.indexName
}
export const getDeleted = (state) => {
    return state.deleted
}